import { render, staticRenderFns } from "./BreadcrumbNode.vue?vue&type=template&id=6b55eb92&scoped=true"
import script from "./BreadcrumbNode.vue?vue&type=script&lang=js"
export * from "./BreadcrumbNode.vue?vue&type=script&lang=js"
import style0 from "./BreadcrumbNode.vue?vue&type=style&index=0&id=6b55eb92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b55eb92",
  null
  
)

export default component.exports